import React from 'react'
import { Link } from 'react-router-dom'
import { SpineAvatar } from '../../types'
import { MyMedia } from 'components/MyMedia'
import { AvatarActions } from './AvatarActions'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'

interface SpineAvatarItemProps {
  avatar: SpineAvatar
  tid?: string
  /** 底部操作栏右侧（如套装列表「移除套装」） */
  actionsEndSlot?: React.ReactNode
  /** 为 true 时，有 authorId 的作者名可点击跳转到列表并按 Uid 筛选（编辑器内套装列表建议 false） */
  authorFilterLink?: boolean
}

export const SpineAvatarItem: React.FC<SpineAvatarItemProps> = ({
  avatar,
  tid,
  actionsEndSlot,
  authorFilterLink = true,
}) => {
  if (!avatar) {
    return null
  }

  return (
    <div className="flex min-h-0 min-w-0 h-full flex-col gap-1 border p-1">
      <div className="flex min-h-0 flex-1 flex-col gap-1">
        <div className="aspect-square w-full shrink-0 overflow-hidden rounded-md bg-black">
          <MyMedia
            alt={avatar.name || avatar.id || 'avatar'}
            videoUrl={avatar.videoPreviewUrl || avatar.videoUrl}
            previewVideoUrl={avatar.videoUrl || avatar.videoPreviewUrl}
            imageUrl={avatar.url}
            lazyVideo
            className="h-full w-full rounded-md"
          />
        </div>

        <div className="text-sm">
          <p className="text-xs text-muted-foreground">
            <DisplayUpdateTime updateTime={avatar.updateTime} />
          </p>
        </div>

        <div className="flex flex-col space-y-1 text-xs">
          <div>
            <span className="text-muted-foreground">Author: </span>
            {authorFilterLink && avatar.authorId ? (
              <Link
                to={`/admin/spine-avatars?uid=${encodeURIComponent(avatar.authorId)}`}
                className="text-primary underline-offset-2 hover:underline font-medium"
              >
                {avatar.authorName || avatar.authorId}
              </Link>
            ) : (
              <span>{avatar.authorName || '-'}</span>
            )}
          </div>
          <div>
            <span className="text-muted-foreground">Client Ver: </span>
            <span>{avatar.clientVer || '-'}</span>
          </div>
          <div>
            <span className="text-muted-foreground">State: </span>
            <span>{avatar.state ?? '-'}</span>
          </div>
        </div>
      </div>

      <div className="mt-auto flex w-full items-center gap-2">
        <AvatarActions avatar={avatar} tid={avatar.tid ?? tid} />
        {actionsEndSlot ? (
          <div className="ml-auto flex shrink-0 items-center">{actionsEndSlot}</div>
        ) : null}
      </div>
    </div>
  )
}
